module.exports = __webpack_public_path__ + "static/media/danxuanweixuan.02ba23dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/inviteNewUsers/share/images/danxuanweixuan.png
// module id = 1151
// module chunks = 0